module.exports = __webpack_public_path__ + "static/media/hair-0.a8fbb61e.svg";